var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Subject } from '@/models/Subject';
import { SubjectLabel } from '@/models/SubjectLabel';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let SubjectLabelSelect = class SubjectLabelSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.subjectLabels = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSubjectLabels();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    async fetchSubjectLabels() {
        this.subjectLabels = await new SubjectLabel()
            .filter({ subject_id: this.selectedArea })
            .limit(999)
            .all();
    }
    async onInput(value) {
        // if (isEqual(this.value, value)) { return; }
        // this.$emit('input', value);
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    async onSelectedAreaChanged(newValue, oldValue) {
        if (newValue === oldValue)
            return;
        this.initialize();
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", String)
], SubjectLabelSelect.prototype, "selectedArea", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], SubjectLabelSelect.prototype, "usePlaceholder", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], SubjectLabelSelect.prototype, "onSelectedAreaChanged", null);
SubjectLabelSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], SubjectLabelSelect);
export default SubjectLabelSelect;
